import { render, staticRenderFns } from "./ServicoControleHorasMovimentacao.vue?vue&type=template&id=43c0b0bb&"
import script from "./ServicoControleHorasMovimentacao.vue?vue&type=script&lang=js&"
export * from "./ServicoControleHorasMovimentacao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports